<template>
  <div class="filters-brand">
    <div class="filters-brand__navigate" v-if="brandsGroup">
      <div
        @click="toggleFiltersGroup(false)"
        :class="
          groupTabIsActive
            ? 'filters-brand__navigate__location__title--inactive'
            : 'filters-brand__navigate__location__title--active'
        "
        class="filters-brand__navigate__location__title--tab"
      >
        {{ brandsObj.title[$i18n.locale] || brandsObj.title.default }}
      </div>
      <div
        v-if="brandsGroup"
        @click="toggleFiltersGroup(true)"
        :class="
          groupTabIsActive
            ? 'filters-brand__navigate__group__title--active'
            : 'filters-brand__navigate__group__title--inactive'
        "
        class="filters-brand__navigate__group__title--tab"
      >
        {{ $t('brand.group.group') }}
        <span v-if="brandDefaultHasGroupActive.length" class="filters-brand__navigate__group__title__circle"></span>
      </div>
    </div>
    <div class="filters-brand__navigate" v-else>
      <div class="filters-brand__navigate__location__title">
        {{ brandsObj.title[$i18n.locale] || brandsObj.title.default }}
      </div>
    </div>
    <template v-if="!isZone">
      <div :class="{ 'filters-brand__tab': brandsGroup }">
        <ui-checkbox
          class="filters-brand__checkbox"
          id="brand-all"
          v-model="all"
          :disabled="groupTabIsActive ? allBrandsGroupCount > 5000 : allBrandsCount > 5000"
          v-if="(!isZone && brandsObj.brands.length > 1) || (groupTabIsActive && brandsGroup.groups.length > 1)"
        >
          <span class="filters-brand__checkbox__label">
            <span class="filters-brand__checkbox__label__name">
              {{ groupTabIsActive ? $t('brand.group.all') : $t('brand.all') }}
            </span>
            <span class="filters-brand__checkbox__label__count">
              {{ groupTabIsActive ? allBrandsGroupCount : allBrandsCount }}
            </span>
          </span>
        </ui-checkbox>
        <ui-checkbox
          class="filters-brand__checkbox"
          :id="`brand-${b.brand.key}`"
          v-for="b in groupTabIsActive ? brandsGroup.groups : brandsObj.brands"
          :key="b.brand.key"
          v-model="model"
          :value="b.brand.key"
          :color="brandDefaultHasGroupActive.length && b.brand.key === brandsGroup.key ? '#da1913' : '#54cad9'"
        >
          <span v-if="!groupTabIsActive" class="filters-brand__checkbox__label">
            <span class="filters-brand__checkbox__label__name">
              {{ b.brand.name }}
              <marker-acronym
                class="filters-brand__checkbox__label__name__acronym"
                v-if="settings.marker.acronym"
                :acronym="b.brand.acronym"
              />
            </span>
            <span class="filters-brand__checkbox__label__count">
              {{ b.brand.location_count }}
            </span>
          </span>
          <span v-else class="filters-brand__checkbox__label">
            <span class="filters-brand__checkbox__label__name">
              {{ b.brand.name[$i18n.locale] || b.brand.name.default }}
            </span>
            <span class="filters-brand__checkbox__label__count">
              {{ b.brand.location_count }}
            </span>
          </span>
          <div class="filters-brand__checkbox__distribution" v-if="withDistribution">
            <span
              class="filters-brand__checkbox__distribution__item"
              v-for="(distribution, idx) in b.location_distribution"
              :key="`distribution-${idx}`"
              :style="{
                width: `calc(${(distribution / b.brand.location_count) * 100}% + 1px)`,
                backgroundColor: colors[idx],
                display: distribution !== 0 ? 'block' : 'none',
              }"
            >
            </span>
          </div>
        </ui-checkbox>
      </div>
    </template>
    <template v-if="isZone">
      <div :class="{ 'filters-brand__tab': brandsGroup }">
        <ui-radio
          class="filters-brand__radio"
          :id="`brand-${b.brand.key}`"
          v-for="b in groupTabIsActive ? brandsGroup.groups : brandsObj.brands"
          :key="b.brand.key"
          v-model="model"
          :value="b.brand.key"
        >
          <span class="filters-brand__radio__label">
            <span class="filters-brand__radio__label__name">
              {{ groupTabIsActive ? b.brand.name[$i18n.locale] || b.brand.name.default : b.brand.name }}
            </span>
            <span class="filters-brand__radio__label__count">
              {{ b.brand.location_count }}
            </span>
          </span>
          <div class="filters-brand__radio__distribution" v-if="withDistribution">
            <span
              class="filters-brand__radio__distribution__item"
              v-for="(distribution, idx) in b.location_distribution"
              :key="`distribution-${idx}`"
              :style="{
                width: `calc(${(distribution / b.brand.location_count) * 100}% + 1px)`,
                backgroundColor: colors[idx],
              }"
            >
            </span>
          </div>
        </ui-radio>
      </div>
    </template>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import UiCheckbox from '@/components/UI/Checkbox.vue'
import UiRadio from '@/components/UI/Radio.vue'
import MarkerAcronym from '@/components/Marker/Acronym.vue'
export default {
  name: 'FilterBrand',
  components: {
    UiCheckbox,
    UiRadio,
    MarkerAcronym,
  },
  props: {
    brandsObj: {
      type: Object,
      required: true,
    },
    activeBrands: {
      type: Array,
      required: true,
    },
    activeGroups: {
      type: Array,
      required: false,
      default: null,
    },
    allBrands: {
      type: Boolean,
      required: true,
    },
    allGroupsBrands: {
      type: Boolean,
      required: true,
    },
    colors: {
      type: Array,
      required: true,
    },
    withDistribution: {
      type: Boolean,
      required: true,
    },
    isZone: {
      type: Boolean,
      required: true,
    },
    isAnalytics: {
      type: Boolean,
      required: true,
    },
    settings: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState({
      groupTabIsActive: state => state.radar.filters.group,

      brandsGroup: state => state.data.brandsGroup,
    }),
    brandDefaultHasGroupActive() {
      return this.brandsGroup
        ? this.brandsGroup?.groups.filter(brandGroup => this.activeBrands.includes(brandGroup.brand.key))
        : []
    },
    model: {
      get() {
        if (this.isZone) {
          return this.activeGroups?.length ? this.activeGroups[0] : this.activeBrands?.[0]
        }
        return [...(this.activeBrands || []), ...(this.activeGroups || [])]
      },
      set(array) {
        const groups = this.brandsGroup?.groups
          .filter(brandGroup => array.includes(brandGroup.brand.key))
          .map(brandGroup => brandGroup.brand.key)
        const brands = this.brandsObj.brands
          .filter(brand => array.includes(brand.brand.key))
          .map(brand => brand.brand.key)

        this.$emit('updateBrands', brands)
        this.$emit('updateGroups', groups)
      },
    },
    all: {
      get() {
        return this.groupTabIsActive ? this.allGroupsBrands : this.allBrands
      },
      set(bool) {
        this.groupTabIsActive ? this.$emit('toggleGroups', bool) : this.$emit('toggle', bool)
      },
    },
    allBrandsCount() {
      return this.brandsObj.brands.reduce((acc, curr) => acc + curr.brand.location_count, 0)
    },
    allBrandsGroupCount() {
      return this.brandsGroup?.groups.reduce((acc, curr) => acc + curr.brand.location_count, 0) ?? 0
    },
  },
  methods: {
    ...mapActions({
      toggleFiltersGroup: 'radar/toggleFiltersGroup',
    }),
  },
}
</script>
<style lang="scss" scoped>
.filters-brand {
  &__navigate {
    display: flex;
    flex-direction: row;
    &__location {
      &__title {
        @include sub-title;
        &--tab {
          transition: color $transition-duration-default $transition-effect-default;
          border-top-left-radius: $radius-tooltip;
          cursor: pointer;
          padding: $spacing-sm / 2;
          font-weight: 600;
        }
        &--active {
          background-color: $grey-alabasterapprox;
          color: $blue-viking;
        }
        &--inactive {
          background-color: $black-light;
        }
      }
    }
    &__group {
      &__title {
        @include sub-title;
        &__circle {
          display: inline-block;
          margin-bottom: 4px;
          border-radius: 50%;
          background-color: #ff2f28;
          width: 6px;
          height: 6px;
        }
        &--tab {
          transition: color $transition-duration-default $transition-effect-default;
          border-top-right-radius: $radius-tooltip;
          cursor: pointer;
          padding: $spacing-sm / 2;
          font-weight: 600;
        }
        &--active {
          background-color: $grey-alabasterapprox;
          color: $blue-viking;
        }
        &--inactive {
          background-color: $black-light;
        }
      }
    }
  }
  &__tab {
    background-color: rgb(248, 248, 248);
    padding: $gutter-xs 5px;
  }
  &__checkbox,
  &__radio {
    margin-bottom: 10px;
    width: 100%;
    &:last-child {
      margin-bottom: 0;
    }
    &__distribution {
      display: flex;
      margin-top: 2px;
      border-radius: 25px;
      overflow: hidden;
      &__item {
        margin-left: -1px;
        border-radius: 25px 0 0 25px;
        height: 6px;
      }
    }
    &__label {
      display: flex;
      justify-content: space-between;
      &__name {
        display: flex;
        align-items: center;
        &__acronym {
          margin-left: 8px;
        }
      }
      &__count {
        font-weight: bold;
      }
    }
  }
}
</style>
